export const homeObjOne = {
  lightBg: false,
  imgStart: "",
  lightTopline: true,
  lightTextDesc: true,
  buttonLabel: "Get Started",
  description:
    "We are an online service connecting Serbian brands with the world, offering a wide range of high-quality products and unique designs.",
  headline: "Lead Generation Online Service",
  lightText: true,
  topLine: "SerBeat Online",
  primary: true,
  img: require("../../images/svg-4.svg").default,
  alt: "Image",
  start: "",
};

export const homeObjTwo = {
  lightBg: true,
  imgStart: "",
  lightTopline: false,
  lightTextDesc: false,
  buttonLabel: "Get Started",
  description:
    "Provide us with your information, and we will respond to you shortly.",
  headline: "Let Us Connect",
  lightText: false,
  topLine: "SerBeat Online",
  primary: false,
  img: require("../../images/svg-4.svg").default,
  alt: "Image",
  start: "true",
};

export const homeObjThree = {
  lightBg: false,
  imgStart: "Start",
  lightTopline: true,
  lightTextDesc: true,
  buttonLabel: "Get Started",
  description:
    "Provide us with your information, and we will respond to you shortly.",
  headline: "Or Leave Your Feedback",
  lightText: true,
  topLine: "SerBeat Online",
  primary: true,
  img: require("../../images/svg-5.svg").default,
  alt: "Image",
  start: "",
};

export const homeObjFour = {
  lightBg: true,
  imgStart: "start",
  lightTopline: false,
  lightTextDesc: false,
  buttonLabel: "Get Started",
  description:
    "We help our clients increase their revenue. Our team of unique specialist can help you achive your business goals",
  headline: "Lead Generetaion Specialist for Online Businesses",
  lightText: false,
  topLine: "Marketing Agency",
  primary: true,
  img: require("../../images/svg-3.svg").default,
  alt: "Image",
  start: "true",
};
